import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import MastersProgram from "./pages/MastersProgram";
import MastersPPMProgram from "./pages/MastersPPMProgram";
import DoctoralProgram from "./pages/DoctoralProgram";
import CertificateCourses from "./pages/CertificateCourses";
import AIHumanitarianCourse from "./pages/AIHumanitarianCourse";
import Courses from "./pages/Courses";
import Scholarship from "./pages/Scholarship";
import Admissions from "./pages/Admissions";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import TermsOfService from "./pages/TermsOfService";

// Scroll to top on route change - runs before render
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  // Scroll immediately on mount and route change
  useEffect(() => {
    // Immediate scroll
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);
  
  // Also scroll on initial load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/program/masters" element={<MastersProgram />} />
            <Route path="/program/masters-ppm" element={<MastersPPMProgram />} />
            <Route path="/program/doctoral" element={<DoctoralProgram />} />
            <Route path="/program" element={<Programs />} />
            <Route path="/certificates" element={<CertificateCourses />} />
            <Route path="/certificate/ai-humanitarian" element={<AIHumanitarianCourse />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/scholarship" element={<Scholarship />} />
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
